module.exports = "https://www.niulinkcloud.cn/_next/static/media/mobile.b18277ceed24611d6a3eed442f912fa1.png";